import customTransfer from "./transfer.vue";
import _Vue from "vue";
const components = [customTransfer];
const install = Vue => {
	if (!Vue) {
		window.Vue = Vue = _Vue;
	}
	components.forEach(component => {
		Vue.component(component.name, component);
	});
};
export default {
	install,
	customTransfer,
};
